import { useAnalytics } from '../analytics/use-analytics';
import { useHost } from '../utils/use-host';

import {
  createLogout,
  useHandleCallback,
  useInitiateChangePassword,
  useInitiateHostedLogin,
  usePostLogin,
} from './auth-hooks';
import { AuthenticationResponse, PostLogin } from './types';
import { useGetOrganisationAuthSettings } from './use-get-organisation-auth-settings';
import { useOrganisation } from './use-organisation';

type UseAuthCallbacks = {
  apiUrl: string;
  setIsAuthenticated: (b: boolean) => void;
  setIsDefaultClientId: (b: boolean) => void;
  setAuthError: (s: string) => void;
  setClientId: (s: string) => void;
  setAuthSystemId: (s: string) => void;
  setAuthenticatedUser: (s: AuthenticationResponse) => void;
  cognitoDomain: string;
  clientId?: string;
};

const useAuthCallbacks = (params: UseAuthCallbacks) => {
  const {
    setAuthSystemId,
    setIsAuthenticated,
    setAuthenticatedUser,
    cognitoDomain,
    clientId,
    apiUrl,
    setAuthError,
    setClientId,
    setIsDefaultClientId,
  } = params;

  const portalHost = useHost();
  const [organisation] = useOrganisation();
  const getOrgSettings = useGetOrganisationAuthSettings({ apiUrl });
  const analytics = useAnalytics();
  const commonHookParams = {
    clientId,
    cognitoDomain,
    getOrgSettings,
    organisation,
    portalHost,
    setClientId,
  };

  const postLogin: PostLogin = usePostLogin({
    setAuthSystemId,
    setAuthenticatedUser,
    setClientId,
    setIsAuthenticated,
    setIsDefaultClientId,
  });

  return {
    getOrgSettings,
    handleCallback: useHandleCallback({ apiUrl, setAuthError, postLogin, setClientId }),
    initiateChangePassword: useInitiateChangePassword(commonHookParams),
    initiateHostedLogin: useInitiateHostedLogin(commonHookParams),
    logout: createLogout({ analytics, apiUrl, clientId, cognitoDomain, portalHost, setIsAuthenticated }),
    postLogin,
  };
};

export { useAuthCallbacks };
